(function () {
  var root = document.getElementById('ornmem');
  if (!root) return;
  var canvases = root.querySelectorAll('.ornmem__preview canvas');
  var nameIn = root.querySelector('#ornmem-name');
  var yearsIn = root.querySelector('#ornmem-years');
  var pick = root.querySelector('#ornmem-pick');
  var own = root.querySelector('#ornmem-own');
  var ownCount = root.querySelector('[data-for="ornmem-own"]');
  var nameCount = root.querySelector('[data-for="ornmem-name"]');
  var err = root.querySelector('.ornmem__error');
  var hidden = {
    name: root.querySelector('[data-ornmem="name"]'),
    years: root.querySelector('[data-ornmem="years"]'),
    line: root.querySelector('[data-ornmem="line"]'),
    flag: root.querySelector('[data-ornmem="flag"]')
  };
  var ready = false;
  var print = document.createElement('canvas');

  var addBtn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
  var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
  if (form) {
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'ornmem-product-form'; form.setAttribute('id', formId); }
    Object.keys(hidden).forEach(function (k) { hidden[k].setAttribute('form', formId); hidden[k].disabled = false; });
  }

  function shape() {
    var el = document.querySelector('input[name^="Shape"]:checked, select[name="options[Shape]"]');
    return el && /heart/i.test(el.value) ? 'heart' : 'circle';
  }
  function lineValue() { return pick.value === '__own' ? own.value : pick.value; }

  // The ornament's outline, in print pixels: the preview shows only what lands on the ceramic.
  function outline(ctx, sh, W, H) {
    ctx.beginPath();
    if (sh === 'heart') {
      var x = W / 2;
      ctx.moveTo(x, H * 0.97);
      ctx.bezierCurveTo(W * -0.04, H * 0.56, W * 0.02, H * 0.02, x, H * 0.2);
      ctx.bezierCurveTo(W * 0.98, H * 0.02, W * 1.04, H * 0.56, x, H * 0.97);
    } else {
      ctx.arc(W / 2, H / 2, W / 2 - 2, 0, Math.PI * 2);
    }
    ctx.closePath();
  }

  function draw() {
    if (!ready || !window.drawOrnament) return;
    var sh = shape(), g = window.ornamentShapes[sh];
    print.width = g.W; print.height = g.H;
    canvases.forEach(function (c) {
      var side = c.dataset.side;
      window.drawOrnament(print.getContext('2d'), {
        side: side, shape: sh, name: nameIn.value || nameIn.placeholder, years: yearsIn.value, line: lineValue()
      }, 1);
      if (c.width !== g.W || c.height !== g.H) { c.width = g.W; c.height = g.H; }
      var ctx = c.getContext('2d');
      ctx.clearRect(0, 0, g.W, g.H);
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.18)'; ctx.shadowBlur = 24; ctx.shadowOffsetY = 8;
      outline(ctx, sh, g.W, g.H); ctx.fillStyle = '#fff'; ctx.fill();
      ctx.restore();
      ctx.save();
      outline(ctx, sh, g.W, g.H); ctx.clip();
      ctx.drawImage(print, 0, 0);
      ctx.restore();
      // The hanging hole.
      ctx.beginPath(); ctx.arc(g.W / 2, sh === 'heart' ? g.H * 0.15 : g.H * 0.08, 22, 0, Math.PI * 2);
      ctx.fillStyle = '#f3f1ee'; ctx.fill();
    });
  }

  function sync() {
    hidden.name.value = nameIn.value.replace(/\s+/g, ' ').trim();
    hidden.years.value = yearsIn.value.replace(/\s+/g, ' ').trim();
    var ln = lineValue().replace(/\s+/g, ' ').trim();
    hidden.line.value = ln && window.ornamentSentence ? window.ornamentSentence(ln.slice(0, 60)) : ln;
    hidden.years.disabled = !hidden.years.value;
    hidden.line.disabled = !hidden.line.value;
    nameCount.textContent = nameIn.value.length + '/24';
    ownCount.textContent = own.value.length + '/60';
    if (hidden.name.value) { root.classList.remove('ornmem--invalid'); err.hidden = true; }
    draw();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && /^(Shape|options\[Shape\])/.test(t.name)) setTimeout(draw, 0);
  });
  pick.addEventListener('change', function () {
    var mine = pick.value === '__own';
    own.hidden = !mine; ownCount.hidden = !mine;
    if (mine) own.focus();
    sync();
  });
  [nameIn, yearsIn, own].forEach(function (el) { el.addEventListener('input', sync); });

  document.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    sync();
    if (!hidden.name.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      root.classList.add('ornmem--invalid');
      err.hidden = false;
      nameIn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      nameIn.focus({ preventScroll: true });
    }
  }, true);

  function loadFont(family, url) {
    return new FontFace(family, 'url(' + url + ')').load().then(function (ff) { document.fonts.add(ff); });
  }
  function start() {
    if (!window.drawOrnament) return setTimeout(start, 50);
    Promise.all([
      loadFont('BIW Lit Title', root.dataset.titleFont),
      loadFont('Arimo', root.dataset.bodyFont),
      loadFont('Arimo Bold', root.dataset.boldFont)
    ]).catch(function () {}).then(function () { ready = true; sync(); });
  }
  sync();
  start();
})();
